import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5a9e65a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "imersonate-bar"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "imersonate-bar-time" }
const _hoisted_5 = { key: 2 }

import useImpersonator from "@/helpers/useImpersonator";
import { useStore } from "@/store";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImpersonateBar',
  setup(__props) {

const store = useStore();
const { impersonator, timer } = useImpersonator();

const user = computed(() => store.getters["user"]);

return (_ctx: any,_cache: any) => {
  return (_unref(impersonator))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createTextVNode(" ACHTUNG: Sie sind aktuell als "),
        (user.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(user.value.email), 1))
          : _createCommentVNode("", true),
        _createTextVNode(" eingeloggt. "),
        (_unref(timer))
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createTextVNode(" Zeit bis zum automatischen Logout: "),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(timer)), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, "Ihre Session ist abgelaufen. Bitte loggen Sie sich erneut ein."))
      ]))
    : _createCommentVNode("", true)
}
}

})